import type { AuthTokens } from '@/types/auth'

const AUTH_STORAGE_KEY = 'xuntu-web-auth'

function getStorage(): Storage | null {
  if (typeof window === 'undefined') return null
  return window.localStorage
}

function isAuthTokens(value: unknown): value is AuthTokens {
  if (!value || typeof value !== 'object') return false
  const candidate = value as Partial<AuthTokens>
  return Boolean(
    candidate.accessToken &&
    candidate.refreshToken &&
    candidate.tokenType &&
    typeof candidate.expiresIn === 'number',
  )
}

export function readAuthTokens(): AuthTokens | null {
  const storage = getStorage()
  if (!storage) return null

  try {
    const raw = storage.getItem(AUTH_STORAGE_KEY)
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    return isAuthTokens(parsed) ? parsed : null
  } catch {
    storage.removeItem(AUTH_STORAGE_KEY)
    return null
  }
}

export function saveAuthTokens(tokens: AuthTokens): void {
  const storage = getStorage()
  storage?.setItem(AUTH_STORAGE_KEY, JSON.stringify(tokens))
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('xuntu:tokens-updated'))
  }
}

export function clearAuthTokens(): void {
  const storage = getStorage()
  storage?.removeItem(AUTH_STORAGE_KEY)
}
